<template>
  <div class="first-box">
    <div class="main-card">
      <!-- 多语言标题 -->
      <div class="card-title">
        {{ $t("studentProgramme.sys3")}}
      </div>

      <!-- 卡片列表：动态渲染 -->
      <div class="cards-list">
        <!-- 无数据状态 -->
        <div v-if="banner.length === 0" class="empty-state">
          <i class="el-icon-picture-outline"></i>
        </div>

        <!-- 动态卡片 -->
        <div
            v-for="(item, index) in banner"
            :key="index"
            class="content-card"
            @click="showModal(index)"
        >
          <!-- 图片类型 -->
          <img
              v-if="item.type === 'image'"
              class="media-content"
              :src="baseURL + item.image"
              @error="handleImgError(index)"
          />

          <!-- 视频类型 -->
          <video
              v-else-if="item.type === 'video'"
              class="media-content"
              :poster="item.image ? baseURL + item.image : ''"
          >
            <source :src="item.url" type="video/mp4">
          </video>

          <!-- 卡片标题 -->
<!--          <div class="card-desc">-->
<!--            <p>{{ item.title || `内容${index+1}` }}</p>-->
<!--          </div>-->
        </div>
      </div>

      <!-- 底部按钮（多语言+跳转） -->
      <button class="action-button" @click="firstFinish">
        {{ $t("studentProgramme.guide5")}}
      </button>
    </div>

    <!-- 弹框：动态展示对应内容 -->
    <div class="modal-mask" v-show="visible" @click="closeModal">
      <div class="modal-content" @click.stop>
        <!-- 图片预览 -->
        <img
            v-if="currentItem.type === 'image'"
            :src="baseURL + currentItem.image"
            class="preview-media"
        />

        <!-- 视频预览 -->
        <video
            v-else-if="currentItem.type === 'video'"
            class="preview-media"
            controls
            controlslist="nodownload"
            autoplay
            :poster="currentItem.image ? baseURL + currentItem.image : ''"
        >
          <source :src="currentItem.url" type="video/mp4">
          您的浏览器不支持视频播放
        </video>

        <!-- 关闭按钮 -->
        <div class="close" @click="closeModal">×</div>

        <!-- 预览标题 -->
<!--        <div class="preview-title"></div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { getBanners } from "@/api/setting";
import { isPC, isPad } from "@/utils/is-rules"; // 无此文件可注释

export default {
  props: {
    detail: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // 动态数据
      banner: [], // 接口返回的banner列表
      baseURL: process.env.VUE_APP_URL,
      step: 1,
      avatar: null,
      avatars: [],

      // 弹框相关
      visible: false,
      currentIndex: -1,
      currentItem: {}, // 当前点击的卡片数据
    };
  },
  created() {
    // 初始化数据
    this.getBanners(); // 请求动态banner数据
  },
  mounted() {
    // 响应式适配（容错处理）
    try {
      this.$store.dispatch("setWidth", window.innerWidth);
      window.addEventListener('resize', this.handleResize);
    } catch (e) {
      console.log("未检测到Vuex，跳过屏幕适配");
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 窗口大小变化处理
    handleResize() {
      try {
        this.$store.dispatch("setWidth", window.innerWidth);
        this.$store.dispatch("setIsPC", isPC());
        this.$store.dispatch("setIsPad", isPad());
      } catch (e) {
        console.info(e)
      }
    },

    // 请求banner动态数据
    getBanners() {
      getBanners().then((v) => {
        this.banner = v.data || [];
      }).catch(err => {
        console.error('获取banner失败:', err);
      });
    },

    // 图片加载错误处理
    handleImgError(index) {
      console.warn(`第${index+1}张图片加载失败`);
      const img = event.target;
      // 替换为默认占位图
      img.src = "https://picsum.photos/800/500?random=" + (index+10);
    },

    // 打开弹框（动态加载对应内容）
    showModal(index) {
      console.log('点击了第', index+1, '个卡片');
      this.currentIndex = index;
      this.currentItem = this.banner[index];
      this.visible = true;
    },

    // 关闭弹框
    closeModal() {
      this.visible = false;
      // 关闭弹框时暂停视频
      const video = document.querySelector('.preview-media');
      if (video && video.tagName === 'VIDEO') {
        video.pause();
      }
    },

    // 开始学习按钮跳转
    firstFinish() {
      // 实际项目中打开对应页面
      this.$router.push({ path: "/adventure" });
    },
  },
};
</script>

<style lang="scss" scoped>
// 响应式断点
$mobile: 768px;
$tablet: 1024px;

.first-box {
  width: 100%;
  height: 100%;
  padding: 2vw 8vw;
  box-sizing: border-box;
}

.main-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  background: #fff;
  border-radius: 60px;
  padding: 30px;
}

.card-title {
  font-size: 36px;
  margin-bottom: 20px;
  color: #333;
  font-family: GenSenRoundedTW, Helvetica, Arial;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  @media (max-width: $mobile) {
    font-size: 28px;
  }
}

// 无数据状态
.empty-state {
  width: 100%;
  text-align: center;
  padding: 40px 0;
  color: #999;

  .el-icon-picture-outline {
    font-size: 60px;
    margin-bottom: 10px;
    color: #ddd;
  }

  p {
    font-size: 18px;
    margin: 0;
  }
}

// 卡片列表（自适应2列）
.cards-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  width: 100%;
  flex: 1;

  // 移动端改为1列
  @media (max-width: $mobile) {
    grid-template-columns: 1fr;
    gap: 15px;
  }
}

// 单个卡片
.content-card {
  background: #f9f9f9;
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  }
}

// 卡片媒体内容
.media-content {
  width: 100%;
  height: 220px;
  object-fit: cover;

  @media (max-width: $mobile) {
    height: 180px;
  }
}

// 卡片标题
.card-desc {
  padding: 10px;
  text-align: center;

  p {
    margin: 0;
    font-size: 16px;
    color: #333;
    font-weight: 500;

    @media (max-width: $mobile) {
      font-size: 14px;
    }
  }
}

// 操作按钮
.action-button {
  margin-top: 20px;
  padding: 12px 30px;
  background: #fcc03a;
  box-shadow: 0px 8px 0 #c28c00;
  border: none;
  border-radius: 30px;
  font-size: 16px;
  color: #333;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0px 10px 0 #c28c00;
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0px 4px 0 #c28c00;
  }

  @media (max-width: $mobile) {
    font-size: 14px;
    padding: 10px 25px;
  }
}

// 弹框遮罩
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

// 弹框内容
.modal-content {
  position: relative;
  max-width: 80%;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

// 预览媒体（图片/视频）
.preview-media {
  max-width: 100%;
  max-height: 75vh;
  border-radius: 10px;
}

// 关闭按钮
.close {
  position: absolute;
  top: -20px;
  right: -20px;
  width: 40px;
  height: 40px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  color: #666;

  &:hover {
    background: #fcc03a;
    color: #fff;
  }
}

// 预览标题
.preview-title {
  margin-top: 15px;
  font-size: 18px;
  color: #fff;
  text-align: center;
  padding: 0 20px;

  @media (max-width: $mobile) {
    font-size: 16px;
  }
}
</style>